import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  Spinner,
} from "@fluentui/react-components";

import { useSelectedCiTypeContext } from "../context/selectedCiTypeContext";
import { useDeleteCiType } from "../hooks/useCiTypeMutations";
import { useNotify } from "../../../shared/components/SuperToast";
import { useTranslation } from "react-i18next";

function CiTypesDeleteDialog({ isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const { value: selectedCiType } = useSelectedCiTypeContext();
  const { notify } = useNotify();

  const {
    mutate: mutateDeleteCiType,
    error,
    isPending,
  } = useDeleteCiType(
    "citypes",
    () => {
      notify(t("item.messages.deleted", { name: selectedCiType.name }), "success");
      setIsOpen(false);
    },
    null,
  );

  const handleConfirmation = () => {
    const publicId = selectedCiType?.public_id;
    if (!publicId) throw new Error("No valid ID for CI type");
    console.log(`Deleting CI type with id ${publicId}`);
    mutateDeleteCiType(publicId);
  };

  if (!selectedCiType) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {t("generic.delete")} {selectedCiType?.name}
          </DialogTitle>
          <DialogContent>
            {t("item.questions.delete", {
              name: selectedCiType?.name,
            })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default CiTypesDeleteDialog;
